import { Box } from "@mui/material";
import React, { memo } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import stylesAnalytics from "../../../styles/pages/analytics.module.scss";
import styles from "../../../styles/pages/analyticseditor.module.scss";
import { emptyHandleTwo } from "../../../lib/functions/utils.lib";

const CompletedVideos = ({ data }) => {
  console.warn("CompletedVideos", data);
  return (
    <>
      <Box
        className={`${styles.analyticBoxThree} ${stylesAnalytics.completeVideoAnalytics} ${styles.commonSmallBoxWrapperAnalytic}`}
      >
        <Box className="commonSmallBox commonSmallBoxAnalytics commonSmallBoxAnalyticsVideo">
          <Box
            className={`${styles.videoListAnalytics} ${stylesAnalytics.ListAnalytics}`}
          >
            <h4>
              Completed Videos
              <span>{emptyHandleTwo(data?.published + data?.released)}</span>
            </h4>
            <p>
              Published Videos <span>{emptyHandleTwo(data?.published)}</span>
            </p>
            <p>
              Released Videos <span>{emptyHandleTwo(data?.released)}</span>
            </p>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default memo(CompletedVideos);
